import type { ThemeProviderProps } from "@emotion/react";
import { ThemeProvider as MuiThemeProvider } from "@mui/material";
import type { ReactElement, ReactNode } from "react";
import type { ThemeConfig } from ".";
import { createTheme } from ".";

interface Props {
  mode: ThemeConfig["mode"];
  children: ReactNode;
}
export const ThemeProvider = ({ children, mode }: Props): ReactElement<ThemeProviderProps> => {
  return <MuiThemeProvider theme={createTheme({ mode })}>{children}</MuiThemeProvider>;
};
